export default __webpack_public_path__ + "static/media/trade_hk_04.f398c39a.png";